import { HTMLProps, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useGetNibudPensionResult } from "../../../api/nibud/useGetNibudPensionResult";
import { PensionContext } from "../../../contexts/pension-robot/PensionContext";
import { toPrice } from "../../../utils/parsers";
import { LoadingStateWrapper } from "../../general/LoadingStateWrapper";
import { sumGoal } from "./NibudModal";
import { NibudField } from "./NibudModalFields";
import { toDecimal } from "./NibudModalStepHousing";

export const NibudModalStepResults: React.FC<HTMLProps<HTMLDivElement>> = () => {
    const { t } = useTranslation('pension');
    const nibudPensionResult = useGetNibudPensionResult();
    const {
        parameters: { expensesInfo },
    } = useContext(PensionContext);
    
    return (
        <LoadingStateWrapper 
            isLoading={nibudPensionResult.isLoading}
            isFetching={nibudPensionResult.isFetching}
            isError={nibudPensionResult.isError}
            isIdle={nibudPensionResult.isIdle}
            >
            <NibudField info={
                {
                    title: t('pension-nibud-results-house'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.house ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { house: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-energy-and-local-taxes'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.energyAndLocalTaxes ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { energyAndLocalTaxes: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-transportation'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.transportation ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { transportation: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-other-utilities'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.otherUtilities ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { otherUtilities: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-unexpected'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.unexpected ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { unexpected: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-leisure'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.leisure ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { leisure: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-household'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.household ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { household: toDecimal(value) } } } };
                    },
                }
            }/>
            <NibudField info={
                {
                    title: t('pension-nibud-results-other'),
                    tooltip: { title: 'TODO', text: 'TODO' },
                    type: 'money-unlockable',
                    get: (params) => '' + (params?.nibud?.calculatedExpenses?.other ?? 0) / 100,
                    onChange: (value) => {
                        return { expensesInfo: { nibud: { calculatedExpenses: { other: toDecimal(value) } } } };
                    },
                }
            }/>
            <div className="ml-4 flex flex-row justify-between items-center">
                <div className="pr-2 pt-8 flex-1 font-bold border-t">Totaal benodigde inkomen</div>
                <div className="pl-2 pt-8 flex-1 font-bold border-t">{ toPrice(
                    sumGoal(expensesInfo?.nibud?.calculatedExpenses),
                    { onlyFullEuros: true }
                )}
                </div>
                <div className="ml-2 flex-2-1"></div>
            </div>
        </LoadingStateWrapper>
    );
};